import { gsap } from 'gsap'
import { CSSRulePlugin } from 'gsap/CSSRulePlugin'
import { GSDevTools } from 'gsap/GSDevTools'

gsap.registerPlugin(CSSRulePlugin, GSDevTools)

export default class FlashMessage {
  constructor(el) {
    this.el = el
    this.setVars()
    this.init()
  }

  setVars() {}

  init() {
    const flashAni = gsap.timeline({
      defaults: { duration: 0.5, opacity: 0, ease: 'power2.out' },
    })
    flashAni.fromTo(
      this.el,
      {
        opacity: 0,
        y: '-=30',
      },
      {
        opacity: 1,
        y: 0,
      },
    )

    flashAni.to(
      this.el,
      {
        opacity: 0,
        y: '-=30',
      },
      '+=4',
    )
  }
}
